<ng-template #notification>
  <ng-content select="fcom-notification, [notifications]" />
</ng-template>

<div class="wrapper flex flex--column rounded-large border">
  <div class="card card-container flex">
    @if (image()) {
      <div class="product-image relative">
        <fcom-image
          class="picture"
          [ratio]="imageRatio()"
          [alt]="image().alt"
          [fillParent]="true"
          [imageData]="image()"
          [style.minHeight.px]="notifications?.clientHeight"
        />
        <div class="notification mr-small has-image" #notifications>
          <ng-container *ngTemplateOutlet="notification"></ng-container>
        </div>
      </div>
    }

    <div
      class="details font-body-1 white-bg surface-primary ps-medium flex-1 font-body-medium"
      [class.has-image]="!!image()"
    >
      @if (!image()) {
        <div class="notification mr-xsmall-x" #notifications>
          <ng-container *ngTemplateOutlet="notification"></ng-container>
        </div>
      }

      <div class="destinations font-heading-3 nordic-blue-900-text text-icon-primary font-headline-small">
        @if (title()) {
          <span>{{ title() }}</span>
        } @else {
          <span [title]="destinations() ? (destinations() | finMap: 'name')?.join(' - ') : ''">
            @for (pair of destinationPairs(); track $index; let last = $last) {
              <span class="destination ms-xsmall-r">
                <span>{{ pair[0] }}</span>
                <fcom-icon class="icon-medium ms-xxsmall-x" [name]="journeyIcon()" />
                <span>{{ pair[1] }}</span>
                @if (!last) {
                  <span>, </span>
                }
              </span>
            }
          </span>
        }
      </div>
      <div class="timeline nordic-blue-900-text text-icon-primary ms-small-t">
        {{ departureDate() }}{{ arrivalDate() ? ' - ' + arrivalDate() : '' }}
      </div>
      @if (passengerAmount()) {
        <div class="passengers pr-xsmall-r">
          {{
            (passengerAmount() === 1 ? 'tripCard.passenger' : 'tripCard.passengers')
              | finLocalization: { passengerAmount: passengerAmount() }
          }}
        </div>
      }
      @if (journeyType() || bookingRef()) {
        <div class="ms-small-t">
          @if (bookingRef()) {
            <fcom-tag class="booking-ref ms-xxsmall-r">{{
              'tripCard.bookingRef' | finLocalization: { bookingRef: bookingRef() }
            }}</fcom-tag>
          }
          @if (journeyType()) {
            <fcom-tag class="flight-type">{{ 'tripCard.tripType.' + journeyType() | finLocalization }}</fcom-tag>
          }
        </div>
      }
      @for (operatingAirlineId of operatingAirlineIds(); track $index) {
        <span
          [attr.data-testid]="'operating-airline-' + operatingAirlineId.airlineCode"
          class="ms-xsmall-l font-body-2 overflow-hidden truncate font-body-small"
        >
          {{
            'tripCard.operatingAirlineMessage'
              | finLocalization: { airlineName: operatingAirlineId.airlineName, airlineId: operatingAirlineId.id }
          }}
        </span>
      }

      @if (!showExpandButton()) {
        <div
          class="flex flex--space-between flex--align-center ms-small-t font-heading-4 nordic-blue-900-text text-icon-primary font-title-medium"
        >
          @if (totalPoints() || flightTotalPriceAmount()) {
            <div>
              @if (totalPoints()) {
                <span data-testid="trip-card-total-points">
                  {{ 'award.points' | finLocalization: { pointsAmount: totalPoints() || 0 } }}&nbsp;+
                </span>
              }
              @if (flightTotalPriceAmount()) {
                <span class="total-amount" data-testid="trip-total-amount">
                  {{ flightTotalPriceAmount() }}
                </span>
              }
            </div>
          }
          @if (showStartOverButton()) {
            <fcom-button
              data-testid="trip-card-modify-button"
              class="start-over"
              (clickBtn)="clickCta($event)"
              [icon]="{ name: SvgLibraryIcon.ARROW_BACK, position: IconPosition.RIGHT }"
              [text]="'tripCard.startOver' | finLocalization"
              [theme]="ButtonTheme.LIGHT_TERTIARY_GHOST"
            />
          }
        </div>
      }

      @if (showExpandButton()) {
        <div class="expand-details flex flex--end ms-small-t">
          <button
            [attr.aria-label]="(expanded() ? 'tripCard.ariaHide' : 'tripCard.ariaShow') | finLocalization"
            [attr.aria-controls]="expandContainerId"
            [attr.aria-expanded]="expanded()"
            [id]="expandButtonId"
            (click)="toggleExpand($event)"
            class="font-body-1 mr-small-l nordic-blue-900-text text-icon-primary underline medium-type font-label-medium"
            data-testid="trip-card-expander-toggle-button"
          >
            <span>{{ (expanded() ? 'tripCard.hideFlights' : 'tripCard.showFlights') | finLocalization }}</span>
            <fcom-icon
              [class.chevron-open]="expanded()"
              class="icon-medium ms-xxsmall-l chevron"
              [name]="SvgLibraryIcon.CHEVRON_DOWN"
            />
          </button>
        </div>
      }
    </div>
  </div>

  @if (showExpandButton()) {
    <div>
      <fcom-expand [open]="expanded()" [ariaId]="expandContainerId" [ariaLabelledBy]="expandButtonId" class="block">
        <div class="expanded-content">
          <ng-content />
        </div>
      </fcom-expand>
    </div>
  }
</div>
